const state = () => ({
    isAutoToReserveInfo: false, // 自动跳转
})

const getters = {}

const mutations = {
    updateAuto(state, value) {
        state.isAutoToReserveInfo = value
    },
}

const actions = {}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
